import { useEffect, useRef, useState } from "react";
import { scrollHint, type ScrollHint } from "./scrollHint";

/**
 * 세로 스크롤 컨테이너에 `data-scroll="none|more|end"` 를 달기 위한 훅 (스타일·동작 그리드).
 * 스크롤바를 숨긴 그리드는 7장↑ 이 아래에 숨어 있어도 손님이 알 길이 없었다 — CSS 가 이 값으로 하단 페이드를 그린다.
 * `itemCount` 가 바뀌면(설정 로드·테마 변경) 다시 측정한다. 컨테이너 크기 변화는 ResizeObserver.
 */
export function useScrollHint<T extends HTMLElement>(itemCount: number): { ref: React.RefObject<T | null>; hint: ScrollHint } {
  const ref = useRef<T | null>(null);
  const [hint, setHint] = useState<ScrollHint>("none");

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => setHint(scrollHint(el.scrollTop, el.clientHeight, el.scrollHeight));
    update();
    el.addEventListener("scroll", update, { passive: true });
    const ro = typeof ResizeObserver === "function" ? new ResizeObserver(update) : null;
    ro?.observe(el);
    return () => {
      el.removeEventListener("scroll", update);
      ro?.disconnect();
    };
  }, [itemCount]);

  return { ref, hint };
}
